export default __webpack_public_path__ + "static/media/edit-location-black-18-dp.95d45c45.svg";